import { render, staticRenderFns } from "./MeasurementUnits.vue?vue&type=template&id=1fb87c48"
import script from "./MeasurementUnits.vue?vue&type=script&lang=js"
export * from "./MeasurementUnits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports